/**
 * As some integrations trigger the insertion of HTML code into the page, this function can be used to
 * ensure that any script tags in the inserted HTML will also be executed.
 * @param target the parent of possible script tag elements.
 */
export function executeHtmlScripts(target: HTMLElement): void {
  target.querySelectorAll('script').forEach(script => {
    let newScriptElem = document.createElement('script');
    newScriptElem.text = script.innerHTML;
    target.appendChild(newScriptElem);
    target.lastChild && target.removeChild(target.lastChild);
  });
}